<template>
    <div class="splashBody" v-if="showSplash">
      <div class="splashScreen">
        <div class="loadingContainer">
          <div class="loadingBox">
            <v-container grid-list-xl>
              <v-flex xs4 sm4 md4 lg12>
            <div class="ai-avatar-container">
  <img src="@/assets/AIANALYST450px.png" alt="AI Avatar" class="ai-avatar">
  <div class="eye-glow left-eye"></div>
  <div class="eye-glow right-eye"></div>
  <div class="orb-container">
    <div class="glowing-orb"></div>
    <!-- <div class="glowing-orb"></div>
    <div class="glowing-orb"></div> -->
  </div>
</div>
            <div class="loadingBarContainer">
              <div class="loadingbar"></div>
            </div>
            <div class="loadingCircle">
              <div class="circleOuter"></div>
              <div class="circleLoader"></div>
            </div>

          </v-flex>
        </v-container>          </div>
        </div>
      </div>
      <div class="splashBehind"></div>
      <!-- <div class="splashBehindTwo"></div> -->
      <notifications ref="notifications"></notifications>
    </div>
  </template>
  
  <script>
  import Notifications from './Notification.vue';
  import codeCompleteAudio from "../assets/audio/Notification2.wav";
  import codeCompleteAudio2 from "../assets/audio/ThinClick.wav";
  
  export default {
    components: {
      Notifications
    },
    data() {
      return {
        showSplash: true,
      };
    },
    mounted() {
      this.startLoading();
    },
    methods: {
      startLoading() {
        setTimeout(() => {
          this.notifyAndSpeak('Loading Analyst Core');
        }, 1000);
  
        setTimeout(() => {
          this.animateLoadingBar();
        }, 2000);
  
        setTimeout(() => {
          this.animateLoadingBox();
        }, 2000);
  
        setTimeout(() => {
          this.animateSplashScreen();
        }, 6000);
  
        setTimeout(() => {
          this.animateLoadingCircle();
        }, 8000);
  
        setTimeout(() => {
          this.showSplash = false;
          document.body.classList.add('visibleSplash');
          this.playSoundAndSpeak('');
        }, 8500);
      },
      notifyAndSpeak(message) {
        this.$refs.notifications.addNotification(message, 'info');
        this.readOutLoud(message);
      },
      notifyAndSpeak2(message) {
        this.$refs.notifications.addNotification(message, 'info');
        this.readOutLoud(message);
        setTimeout(() => {
          const audio = new Audio(codeCompleteAudio2);
          audio.volume = 0.5;  // Set volume to 50%
          audio.play();
        }, 1800);
      },
      playSoundAndSpeak(message) {
        this.readOutLoud(message);
        this.$refs.notifications.addNotification(message, 'success');
        setTimeout(() => {
          const audio = new Audio(codeCompleteAudio);
          audio.volume = 0.25;  // Set volume to 50%
          audio.play();
        }, 3000);
      },
      readOutLoud(msg) {
        const speech = new SpeechSynthesisUtterance();
        const voiceName = 'Google UK English Female';
        speech.volume = 1;
        speech.rate = 1;
        speech.pitch = 1;
        speech.voice = speechSynthesis.getVoices().find(voice => voice.name === voiceName);
        speech.text = msg;
        window.speechSynthesis.speak(speech);
      },
      animateLoadingBar() {
        const loadingBar = document.querySelector('.loadingbar');
        loadingBar.style.transition = 'left 6s';
        loadingBar.style.left = '0';
      },
      animateLoadingBox() {
        const loadingBox = document.querySelector('.loadingBox');
        loadingBox.style.transition = 'opacity 1s';
        loadingBox.style.opacity = '1';
      },
      animateSplashScreen() {
        const splashScreen = document.querySelector('.splashScreen');
        splashScreen.style.transition = 'top 6s';
        splashScreen.style.top = '-100%';
      },
      animateLoadingCircle() {
        const loadingCircle = document.querySelector('.loadingCircle');
        loadingCircle.style.transition = 'opacity 0.5s';
        loadingCircle.style.opacity = '0';
      },
    },
  };
  </script>
  
  <style scoped>
  body {
    overflow: hidden;
  }
  
  body.visibleSplash {
    overflow: visible !important;
  }
  /* Wrapper to center the entire avatar */
.ai-avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: #000; /* Black background for better glow contrast */
  overflow: hidden;
}

.ai-avatar-container {
  position: relative;
  width: 450px;
  height: 420px;
}

.ai-avatar {
  width: 80%;
  height: 80%;
  z-index: 1;
  align-content: center;
  left: 700px;
  right: 0px;
}

.eye-glow {
  position: absolute;
  width: 20px;
  height: 20px;
  background: rgba(0, 191, 255, 0.8); /* Glowing blue color */
  border-radius: 50%;
  box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6); /* Increased blur size */
  z-index: 2;
  animation: eyeGlowPulse 4s infinite ease-in-out; /* Added animation */
  filter: blur(3px); /* Added blur effect */
}

.left-eye {
  top: 168px; /* Adjust based on avatar image */
  left: 880px; /* Adjust based on avatar image */
}

.right-eye {
  top: 170px; /* Adjust based on avatar image */
  left: 950px; /* Adjust based on avatar image */
}

/* Keyframes for the pulsating glow */
@keyframes eyeGlowPulse {
  0% {
    opacity: 0.8;
    box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6);
  }
  50% {
    opacity: 0.4;
    box-shadow: 0 0 25px 15px rgba(0, 191, 255, 0.4); /* Increase glow size */
  }
  100% {
    opacity: 0.8;
    box-shadow: 0 0 15px 10px rgba(0, 191, 255, 0.6);
  }
}

.orb-container {
  position: absolute;
  top: 50%;
  left: 860px;
  transform: translate(-50%, -50%);
  width: 450px;
  height: 420px;
  z-index: 0;
  animation: rotateOrbs 6s linear infinite;
}

.glowing-orb {
  position: absolute;
  width: 30px;
  height: 30px;
  background: rgba(0, 191, 255, 0.7);
  border-radius: 50%;
  box-shadow: 0 0 20px 10px rgba(0, 191, 255, 0.6);
  animation: glowPulse 3s ease-in-out infinite;
}

.glowing-orb:nth-child(1) {
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.glowing-orb:nth-child(2) {
  top: 50%;
  left: 90%;
  transform: translate(-50%, -50%);
}

.glowing-orb:nth-child(3) {
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes rotateOrbs {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes glowPulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

  .splashScreen {
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 0;
    left: 0;
    background: #ffffff00;
    border-bottom: 5px solid #333;
    overflow: hidden;
  }
  
  .loadingContainer {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    overflow: hidden;
  }
  
  .loadingBox {
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  
  .splashLogo {
    width: 50%;
    margin: 0 0 50px;
  }
  
  .loadingBarContainer {
    width: fit-content;
    background: #e1dcdc;
    height: 10px;
    display: block;
    margin: 50px 0 0;
    overflow: hidden;
  }
  
  .loadingbar {
    width: 100%;
    height: 10px;
    background: #579a3ae5;
    position: absolute;
    left: -100%;
  }
  
  .loadingCircle {
    width: 75px;
    height: 75px;
    margin: 30px auto 0;
    background: #fff;
    display: block;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
  }
  
  .circleOuter {
    width: 60px;
    height: 60px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
  
  .circleLoader {
    width: 75px;
    height: 75px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(125, 185, 232, 0) 100%);
    position: absolute;
    right: 50%;
    bottom: 50%;
    transform-origin: bottom right;
    z-index: 1;
    animation: rotateLoader 1.5s linear infinite;
  }
  
  @keyframes rotateLoader {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .splashBehind {
    background: rgba(193, 180, 180, 0);
    width: 100%;
    height: 90vh;
  }
  
  .splashBehindTwo {
    background: #000000;
    width: 0;
    height: 0;
  }
  </style>
  